import {
  createContext, useState, useEffect, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import Loader from '../../components/Loader';
import useAuth from '../../hooks/useAuth';
import useQueryBackups from '../../hooks/useQueryBackups';

export const BackupsContext = createContext();

export default function BackupsProvider({ children }) {
  const { authIsLoading, handleLogout } = useAuth();
  const [backups, setBackups] = useState([]);

  const {
    data, isFetching, isLoading, error,
  } = useQueryBackups({
    enabled: !authIsLoading, hasGroup: false,
  });

  useEffect(() => {
    if (!isFetching && !error) {
      setBackups(data);
    }
  }, [data, isFetching]);

  const value = useMemo(() => (
    {
      isFetching,
      isLoading,
      backups,
    }
  ), [isFetching, backups, isLoading]);

  if (error) {
    handleLogout();

    return <Loader />;
  }

  return (
    <BackupsContext.Provider value={value}>
      {children}
    </BackupsContext.Provider>
  );
}

BackupsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
